export const CLIENTS_SLUGS = {
    DANONE_ONE: 'danone-one',
    JTI_CONNECT: 'jti-connect',
    DOTS: 'dots',
    DOTS_II: 'dots-ii',
    KC: 'kimberly-one',
    SALESBOOK: 'salesbook-one',
    WWP: 'wwp-winwiththepartner',
    SP: 'shell-somosprotagonistas',
    WTS: 'beiersdorf-wts',
    MARS: 'mars-betthertogether',
    SAVENCIA: 'savencia-one',
    MITSUBISHI: 'one-mitsubishi',
    AURA: 'aura-one',
    LESAFFRE: 'lesaffre-one',
    PFIZER: 'one-pfizer',
    BRANCA: 'branca-one',
    AXUM: 'axum-one',
    MEGALABS: 'one-megalabs',
    TURBO: 'one-turbo',
}

/**
 * @description Campos del perfil que NO son editables por cliente.
 * Sin entrada = todos los campos son editables.
 * Para deshabilitar un campo en un cliente, agregar su slug aquí.
 * fields: "Email", "Teléfono", "Nombre", "Apellido", "Rol", "Area"
 */
export const PROFILE_EDITABLE_FIELDS: Record<string, string[]> = {
    [CLIENTS_SLUGS.SP]: ['Teléfono', 'Email'],
    [CLIENTS_SLUGS.DOTS_II]: [],
}
// Clientes que no deben ver el modal de siguiente formulario y salir directamente a la tienda
export const SKIP_NEXT_FORM_ALERT = []

// Slugs donde los comentarios están deshabilitados (botón + sección de comentarios ocultos)
export const COMMENTS_DISABLED_SLUGS = [
    // CLIENTS_SLUGS.PFIZER queda desactivado desde clients comments_enabled
]
